import { useEffect, useRef, useState } from 'react';

// Long enough to read "Kopiert", short enough that copying again says it again.
const COPIED_MS = 2000;

const useCopyToClipboard = () => {
    const [isCopied, setIsCopied] = useState(false);
    const timer = useRef<ReturnType<typeof setTimeout>>(undefined);
    useEffect(() => () => clearTimeout(timer.current), []);

    const copy = async (text: string) => {
        await navigator.clipboard.writeText(text);
        setIsCopied(true);
        clearTimeout(timer.current);
        timer.current = setTimeout(() => setIsCopied(false), COPIED_MS);
    };

    return { isCopied, copy };
};

export default useCopyToClipboard;
